import { createContext, useContext } from 'react';
import { useMarkets } from '../hooks/useMarkets';

const MarketContext = createContext(null);

export function MarketProvider({ children }) {
  const { markets, predictions, loading, error, refetch } = useMarkets();

  return (
    <MarketContext.Provider value={{ markets, predictions, loading, error, refetch }}>
      {children}
    </MarketContext.Provider>
  );
}

export function useMarketContext() {
  const context = useContext(MarketContext);
  if (!context) {
    throw new Error('useMarketContext must be used within MarketProvider');
  }
  return context;
}
